import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BaseSiteService } from '@spartacus/core';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { getNewOnboardingUrl, isLegacyRegisterPath } from './constants';

@Component({
    selector: 'app-release-banner',
    templateUrl: './release-banner.component.html',
    styleUrls: ['./release-banner.component.scss'],
    standalone: false
})
export class ReleaseBannerComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private baseSiteId: string = '';
  newJourneyUrl: string = '';

  showBanner: boolean = false;

  constructor(
    private baseSiteService: BaseSiteService,
    private readonly cdr: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Re-check on every navigation: the banner only belongs on the legacy register page.
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.checkPage();
        this.cdr.detectChanges();
      });

    this.baseSiteService.getActive()
      .pipe(takeUntil(this.destroy$))
      .subscribe(baseSiteId => {
        this.baseSiteId = baseSiteId || 'vsh';
        this.checkPage();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.newJourneyUrl = '';
  }

  private checkPage(): void {
    this.showBanner = isLegacyRegisterPath(window.location.pathname, this.baseSiteId);
    this.newJourneyUrl = this.showBanner ? getNewOnboardingUrl(this.baseSiteId) : '';
  }
}
